module.exports = __webpack_public_path__ + "img/enterprise-security-solutionsimg-4.9a30d150.png";